import { render, staticRenderFns } from "./-pc.vue?vue&type=template&id=05f64e37&scoped=true&"
import script from "./-pc.vue?vue&type=script&lang=js&"
export * from "./-pc.vue?vue&type=script&lang=js&"
import style0 from "./-pc.vue?vue&type=style&index=0&id=05f64e37&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f64e37",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/workspace/DEPLOY/ibu-owt-core/ibu-owt-core-owt-ssr-nuxt/components/SvgIcon.vue').default,Feedback: require('/app/workspace/DEPLOY/ibu-owt-core/ibu-owt-core-owt-ssr-nuxt/components/feedback/index.vue').default})
